import { GenerateModalWithSuspense } from "@libs/modal-panels/modal-registry-helpers";
import { iModalProps } from "@libs/modal-panels/modal-registry-model";
import React from "react";

const MetaCustomAudienceDetailModal = React.lazy(
  () => import("./meta-custom-audience-detail.modal"),
);

const MetaCustomAudienceDetail: iModalProps<
  typeof MetaCustomAudienceDetailModal,
  {
    audienceId: string;
    onUpdated?: () => void;
  }
> = {
  name: "meta-custom-audience-detail",
  component: GenerateModalWithSuspense(MetaCustomAudienceDetailModal),
};

export default MetaCustomAudienceDetail;
